import NoResult from "./NoResult";

export default NoResult;